import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import { computed, type HTMLAttributes } from 'vue';
import {
  CheckboxRoot,
  CheckboxIndicator,
  useForwardPropsEmits,
  type CheckboxRootProps,
  type CheckboxRootEmits,
} from 'reka-ui';
import { Check, Minus } from '@lucide/vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    defaultValue: {},
    modelValue: {},
    disabled: { type: Boolean },
    value: {},
    id: {},
    trueValue: {},
    falseValue: {},
    asChild: { type: Boolean },
    as: {},
    name: {},
    required: { type: Boolean },
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, ...rest } = props;
    return rest;
  }),
  emit
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CheckboxRoot), _mergeProps(_unref(forwarded), {
    class: 
      _unref(cn)(
        'peer size-4 shrink-0 rounded border border-input bg-card transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        props.class
      )
    
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(CheckboxIndicator), { class: "flex items-center justify-center" }, {
        default: _withCtx(() => [
          (__props.modelValue === 'indeterminate')
            ? (_openBlock(), _createBlock(_unref(Minus), {
                key: 0,
                class: "size-3.5"
              }))
            : (_openBlock(), _createBlock(_unref(Check), {
                key: 1,
                class: "size-3.5"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})